export enum Parameters {
  HoldTime = "holdTime",
}
